<div class="white-box main-black mt-4 p-4 border-radius"> 
	<div class="row">
		<div class="col">
			<h4>
				{{'utilization.meter_energy_report' | translate}}
			</h4>
		</div>
	</div>
	<div class="d-flex flex-wrap py-4">
			<div class="col-3 pl-0">
				<label class="mr-2">{{'g.select_year' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="yearList"
					bindLabel="label"
					bindValue="id"
					placeholder="{{'g.select_year' | translate}}"
					name="year"
					[(ngModel)]="selectedYear"
					[clearable]="false"
					(change)="selectYear()"
				></ng-select>
			</div>

			<div class="col-3" *ngIf="selectedYear != allYearsId">
				<label class="mr-2">{{'site.select_period_type' | translate}}</label>
				<ng-select
					[items]="periodTypes"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'site.select_period_type' | translate}}"
					name="period_type"
					[(ngModel)]="selectedPeriodType"
					[clearable]="false"
					(change)="selectPeriodType()"
				></ng-select>
			</div>

			<div *ngIf="selectedPeriodType == periods.QUARTERLY && selectedYear != allYearsId" class="col-3">
				<label class="mx-2">{{'g.select_quarter' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="quarterList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'g.select_quarter' | translate}}"
					name="quarter"
					[(ngModel)]="selectedQuarter"
					[clearable]="false"
					(ngModelChange)="loadAllData()"
				></ng-select>
			</div>

			<div *ngIf="selectedPeriodType == periods.MONTHLY && selectedYear != allYearsId" class="col-3">
				<label class="mx-2">{{'g.select_month' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="monthList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'g.select_month' | translate}}"
					name="year"
					[(ngModel)]="selectedMonth"
					[clearable]="false"
					(ngModelChange)="loadAllData()"
				></ng-select>
			</div>
			
			<!-- select Device Type -->
			<div class="col-3">
				<label class="mx-2">{{'iotemeter_site_energy_report.select_meter_type' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="devicesList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'iotemeter_site_energy_report.select_meter_type' | translate}}"
					name="device_type"
					[(ngModel)]="selectedDeviceType"
					[clearable]="false"
					(ngModelChange)="loadAllData()"
				></ng-select>
			</div>
	</div>

	<sct-custom-table
		[columnsConfig]="meterEnergyReportTableConfig.column"
		[data]="meterEnergyReportTableConfig.data"
		[config]="meterEnergyReportTableConfig.config"
	>
	</sct-custom-table>
</div>